import { NAMESPACE } from 'react/api/actions/base';

export const actions = {
  login: `${NAMESPACE}_AUTH_LOGIN`,
  loginFailure: `${NAMESPACE}_AUTH_LOGIN_ERROR`,
  loginOnChange: `${NAMESPACE}_AUTH_LOGIN_ON_CHANGE`,
  logged: `${NAMESPACE}_AUTH_LOGGED`,
  loaded: `${NAMESPACE}_AUTH_LOADED`,
  logout: `${NAMESPACE}_AUTH_LOGOUT`,
  request: `${NAMESPACE}_AUTH_REQUEST`,
  setAttr: `${NAMESPACE}_SET_ATTR`,
  setTokens: `${NAMESPACE}_SET_TOKENS`,
  setRecaptchaResponse: `${NAMESPACE}_SET_RECAPTCHA_RESPONSE`,
  getIdentityProvidersListRequest: `${NAMESPACE}_GET_IDENTITY_PROVIDERS_LIST_REQUEST`,
  getIdentityProvidersListSucceeded: `${NAMESPACE}_GET_IDENTITY_PROVIDERS_LIST_SUCCEEDED`,
  externalAuthError: `${NAMESPACE}_EXTERNAL_AUTH_ERROR`,
  showErrorsAtLogin: `${NAMESPACE}_SHOW_ERRORS_AT_LOGIN`,
  showErrorsAtForgotPass: `${NAMESPACE}_SHOW_ERRORS_AT_FORGOT_PASS`,
  showSuccessAtForgotPass: `${NAMESPACE}_SHOW_SUCCESS_AT_FORGOT_PASS`,
  forgotPassBacktoInitialState: `${NAMESPACE}_FORGOT_PASS_BACK__TO_INITIAL_STATE`,
  showTimeoutLogoffNotice: `${NAMESPACE}_SHOW_TIMEOUT_LOGOFF_NOTICE`,
};

export const actionCreators = {
  request: () => ({ type: actions.request }),
  login: () => ({ type: actions.login }),
  logout: () => ({ type: actions.logout }),
  onChange: (payload) => ({ type: actions.loginOnChange, payload }),
  setAttr: (payload) => ({ type: actions.setAttr, payload }),
  setTokens: (payload) => ({ type: actions.setTokens, payload }),
  setRecaptchaResponse: (payload) => ({ type: actions.setRecaptchaResponse, payload }),
  getIdentityProvidersListSucceeded: (payload) => (
    { type: actions.getIdentityProvidersListSucceeded, payload }
  ),
  getIdentityProvidersListRequest: () => (
    { type: actions.getIdentityProvidersListRequest }
  ),
  showErrorsAtLogin: (payload) => (
    { type: actions.showErrorsAtLogin, payload }
  ),
  showErrorsAtForgotPass: (payload) => (
    { type: actions.showErrorsAtForgotPass, payload }
  ),
  showSuccessAtForgotPass: (payload) => (
    { type: actions.showSuccessAtForgotPass, payload }
  ),
  forgotPassBacktoInitialState: () => (
    { type: actions.forgotPassBacktoInitialState }
  ),
  showTimeoutLogoffNotice: () => (
    { type: actions.showTimeoutLogoffNotice }
  )
};

export default {
  actions,
  actionCreators
};
